import * as React from 'react';
import aiStyles from '../AIWorkflowGuide/styles.module.scss';
import styles from './FeatureEmptyGuideCard.module.scss';

export type FeatureEmptyGuideStep = {
  body: React.ReactNode;
};

export type FeatureEmptyGuideMediaStep = {
  src: string;
  alt: string;
  body: React.ReactNode;
};

export type FeatureEmptyGuideCardProps = {
  /** Large heading above everything (e.g. "No collections created"). */
  title?: React.ReactNode;
  /** Intro context above steps or media (e.g. Collections empty state). */
  info?: React.ReactNode;
  /** Numbered steps (e.g. Shares empty state). */
  steps?: FeatureEmptyGuideStep[];
  /** Single illustrated block: image then body (e.g. Collections). */
  mediaStep?: FeatureEmptyGuideMediaStep;
};

export const FeatureEmptyGuideCard: React.FC<FeatureEmptyGuideCardProps> = ({
  title,
  info,
  steps = [],
  mediaStep,
}) => (
  <div className={aiStyles.guideContainer}>
    {title ? <h3 className={styles.emptyTitle}>{title}</h3> : null}
    {info ? <div className={styles.infoIntro}>{info}</div> : null}
    {mediaStep ? (
      <div className={aiStyles.guideStep}>
        <div className={styles.mediaStep}>
          <div className={styles.mediaBody}>{mediaStep.body}</div>
          <img src={mediaStep.src} alt={mediaStep.alt} className={styles.mediaImage} />
        </div>
      </div>
    ) : (
      <div className={aiStyles.guideSteps} style={{ marginTop: 0 }}>
        {steps.map((step, index) => (
          <div key={index} className={aiStyles.guideStep}>
            <div className={styles.stepRow}>
              <div className={aiStyles.stepNumber}>{index + 1}</div>
              <div className={styles.stepBody}>{step.body}</div>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default FeatureEmptyGuideCard;
